module.exports = __webpack_public_path__ + "static/media/tracking-url-logo.fa9fbdcd.png";